module.exports = __webpack_public_path__ + "img/hr-chat.96ba2031.svg";